import clsx from "clsx";

import { Info } from "@chef/icons/small";
import { useAppDispatch } from "@chef/state-management/hooks";
import { openModal } from "@chef/state-management";

import { intl } from "./DeliveryTimeAdjustedWarning.Intl";

interface DeliveryTimeAdjustedWarningProps {
  BlockContent: () => JSX.Element | null;
}

export const DeliveryTimeAdjustedWarning = ({
  BlockContent,
}: DeliveryTimeAdjustedWarningProps) => {
  const dispatch = useAppDispatch();
  const contentExists = !!BlockContent();

  const onClick = () => {
    if (!contentExists) {
      return;
    }

    dispatch(
      openModal({
        id: "DELIVERY_TIME_ADJUSTED",
        BlockContent,
      }),
    );
  };

  return (
    <div>
      <button
        className={clsx(
          "text-sm text-left text-error content-center flex items-center ",
          !contentExists && "cursor-default",
        )}
        onClick={onClick}
      >
        <Info />

        <span className="pl-2">{intl.DELIVERY_TIME_ADJUSTED}</span>
      </button>
    </div>
  );
};
